import { render, staticRenderFns } from "./InvoiceOptions.vue?vue&type=template&id=2132a801&"
import script from "./InvoiceOptions.vue?vue&type=script&lang=js&"
export * from "./InvoiceOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports